import { Accordion } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Colors, GreyPallet } from "../../../../../config/styles";

interface StyledAccordionProps {
  accordioncolor: string;
}

export const StyledAccordion = styled(Accordion)<StyledAccordionProps>(({ accordioncolor }) => ({
  boxShadow: "none",
  marginBottom: 10,
  "&::before": {
    content: "none",
  },

  "& .MuiAccordionSummary-root": {
    backgroundColor:
      accordioncolor === "direto"
        ? Colors.Direto
        : accordioncolor === "inverso"
        ? Colors.Inverso
        : accordioncolor === "reitoria"
        ? Colors.Reitoria
        : accordioncolor === "cet"
        ? Colors.Cet
        : GreyPallet.Black,
    color: "white",
    borderRadius: "15px",
    height: "60px !important",

    "&.Mui-expanded": {
      minHeight: "60px !important",
    },
  },
  "& .MuiAccordionDetails-root": {
    backgroundColor:
      accordioncolor === "direto"
        ? Colors.Direto
        : accordioncolor === "inverso"
        ? Colors.Inverso
        : accordioncolor === "reitoria"
        ? Colors.Reitoria
        : accordioncolor === "cet"
        ? Colors.Cet
        : GreyPallet.Black,
    color: "white",
    borderRadius: "15px",
    marginTop: 10,
    marginBottom: 10,
  },
  "& .MuiSvgIcon-root": {
    color: "white",
  },
  "&.Mui-expanded": {
    margin: 0,
  },
}));
